import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { Button } from '../../../../../../components/button/button';
import { Header } from '../../../../../../components/header';
import { AnimatedBox } from '../../components/animated-box/animated-box';

export const DashboardEcoOze: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { t: tc } = useTranslation('common');

  return (
    <AnimatedBox marginBottom={6} padding={3} backgroundColor="var(--color-element)">
      <Header title={t('ecoOze.header')} />
      <Box
        sx={{
          height: 235,
          width: '100%',
          backgroundImage: 'url("images/home-eco.png")',
          backgroundSize: 'contain',
          backgroundPosition: 'top',
          backgroundRepeat: 'no-repeat',
          marginBottom: 3,
        }}
      />
      <Button
        type="accent"
        size="small"
        center
        fullWidth={false}
        onClick={() => window.open('https://zamel.io/eko-oze-pv', '_blank')}
      >
        {tc('buttons.seeMore')}
      </Button>
    </AnimatedBox>
  );
};
